import { atom, selector } from 'recoil'

import {
  type DropdownOption,
  type EventInfo,
} from '~/features/event-info/types/event-info'

export const isModalOpenState = atom({
  key: 'isModalOpenState',
  default: {
    isOpen: false,
    contents: '',
  },
})

export const isPaymentModalOpenState = atom({
  key: 'isPaymentModalOpenState',
  default: {
    isOpen: false,
    contents: {
      productName: '',
      amount: 0,
      orderId: '',
      userId: 0,
      paymentKey: '',
      paymentType: '',
    },
  },
})

export const isNestedModalOpenState = atom({
  key: 'isNestedModalOpenState',
  default: {
    isOpen: false,
    contents: '',
  },
})

export const circleTabState = atom({
  key: 'circleTabState',
  default: 0,
})

export const eventInfoTabState = atom({
  key: 'eventInfoTabState',
  default: 0,
})

export const mypageTabState = atom({
  key: 'mypageTabState',
  default: 0,
})

export const inquiryTabState = atom({
  key: 'inquiryTabState',
  default: 0,
})

export const selectedApplicationIdState = atom({
  key: 'selectedApplicationIdState',
  default: '',
})

export const eventListState = atom<EventInfo[]>({
  key: 'eventListState',
  default: [],
})

export const eventListDropdownOptionsState = selector<DropdownOption[]>({
  key: 'dropdownOptionsState',
  get: ({ get }) => {
    const eventList = get(eventListState)

    return [...eventList]
      .sort((a, b) => b.round - a.round)
      .map((event) => ({
        value: event.id,
        label: event.name!,
      }))
  },
})

export const selectedEventIdState = atom<number>({
  key: 'selectedEventIdState',
  default: selector({
    key: 'selectedEventIdDefault',
    get: ({ get }) => {
      const options = get(eventListDropdownOptionsState)

      return options.length > 0 ? options[0].value : 0
    },
  }),
})

export const generalParticipationInfoTabState = atom({
  key: 'generalParticipationInfoTabState',
  default: 0,
})

export const shopEventIdState = atom({
  key: 'shopEventIdState',
  default: 0,
})

export const ticketInfoTabState = atom({
  key: 'ticketInfoTabState',
  default: 0,
})

export const ticketDetailParamsState = atom({
  key: 'ticketDetailParamsState',
  default: {
    eventTicketId: 0,
  },
})

export const selectedRefundIdState = atom({
  key: 'selectedRefundId',
  default: 0,
})

export const qrModalValueState = atom({
  key: 'qrModalValueState',
  default: {
    ticketType: '',
    qrCode: '',
  },
})

export const keyCodeState = atom({
  key: 'keyCodeState',
  default: {
    key: '',
    code: '',
  },
})
